import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { px2rem } from '../utils/helpers/style.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var selectSizingsNative = {
  s: {
    height: 48,
    topBarHeight: 64,
    fontSize: 16,
    valueTop: -3
  },
  m: {
    height: 56,
    topBarHeight: 72,
    fontSize: 18,
    valueTop: -2
  },
  l: {
    height: 64,
    topBarHeight: 80,
    fontSize: 18,
    valueTop: 0
  }
};
var selectAttributesNative = {
  color: 'primary',
  sizings: selectSizingsNative,
  borderWidth: 2,
  borderStyle: 'full',
  label: {
    size: 12,
    color: 'label.filled',
    disabled: 'label.disabled',
    selectedColor: 'text'
  },
  // variables for the select screen
  screen: {
    paddingTop: 4,
    leftMargin: 16,
    rightMargin: 24,
    fontSize: 18,
    divider: {
      fontSize: 18,
      height: 64
    },
    background: 'background',
    text: 'text',
    topBar: {
      background: 'background.secondary',
      leftMargin: 16,
      searchHeight: 64,
      searchOffset: 4
    }
  },
  divider: {
    fontSize: 18,
    background: 'background.secondary',
    height: 64
  },
  borderColor: {
    inactive: 'border.inactive',
    disabled: 'border.disabled',
    readOnly: 'background'
  },
  background: {
    disabled: 'input.disabled'
  },
  textColor: {
    disabled: 'text.disabled'
  },
  selectionItem: {
    height: 56
  },
  confirmButton: {
    height: 64
  }
};
var selectThemeNative = _objectSpread(_objectSpread({}, selectAttributesNative), {}, {
  variants: {
    condensed: {
      borderStyle: 'bottomOnly'
    }
  }
});
var selectSizingsWeb = {
  s: {
    height: 48,
    label: {
      top: px2rem(5)
    },
    heading: {
      fontSize: px2rem(16),
      padding: {
        top: px2rem(19),
        right: px2rem(38),
        bottom: px2rem(5),
        left: px2rem(14),
        bottomOnly: {
          top: px2rem(21),
          right: px2rem(40),
          bottom: px2rem(7),
          left: px2rem(16)
        }
      }
    },
    caret: {
      top: px2rem(13)
    }
  },
  m: {
    height: 56,
    label: {
      top: px2rem(9)
    },
    heading: {
      fontSize: px2rem(18),
      padding: {
        top: px2rem(19),
        right: px2rem(38),
        bottom: px2rem(5),
        left: px2rem(14),
        bottomOnly: {
          top: px2rem(21),
          right: px2rem(40),
          bottom: px2rem(7),
          left: px2rem(16)
        }
      }
    },
    caret: {
      top: px2rem(16)
    }
  },
  l: {
    height: 64,
    label: {
      top: px2rem(13)
    },
    heading: {
      fontSize: px2rem(18),
      padding: {
        top: px2rem(28),
        right: px2rem(40),
        bottom: px2rem(12),
        left: px2rem(14),
        bottomOnly: {
          top: px2rem(30),
          right: px2rem(42),
          bottom: px2rem(12),
          left: px2rem(16)
        }
      }
    },
    caret: {
      top: px2rem(20)
    }
  }
};
var selectAttributesWeb = {
  color: 'primary',
  background: 'input.background',
  error: 'alert',
  textColor: 'text',
  borderStyle: 'full',
  height: px2rem(64),
  sizings: selectSizingsWeb,
  label: {
    color: 'label.filled',
    fontWeight: 400,
    fontSize: px2rem(12),
    top: px2rem(13)
  },
  inactive: 'border.inactive',
  disabled: {
    label: 'label.disabled',
    background: 'input.disabled'
  }
};
var selectThemeWeb = _objectSpread(_objectSpread({}, selectAttributesWeb), {}, {
  variants: {
    condensed: {
      borderStyle: 'bottomOnly'
    }
  }
});

export { selectThemeNative, selectThemeWeb };
